/* ParfumLab 360: formül karşılaştırma (en fazla 3 parfüm; seçim tarayıcıda saklanır).
   - Her [data-plr-compare="handle"] düğmesi seçimi açar/kapatır (ürün kartları, ürün sayfası).
     Etiketler data-label-on / data-label-off'tan; yoksa ürün sayfası etiketleri.
   - İki ve daha fazla formül seçiliyken altta karşılaştırma şeridi (sepet, ürün ve karşılaştırma sayfaları hariç).
   - Karşılaştırma sayfası (sections/pl-compare-page): gizli veri satırlarından seçilen formüllerin tablosu. */
(() => {
  const KEY = 'pl360_compare';
  const MAX = 3;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const COMPARE_URL = `${root}collections/all?view=pl-karsilastir`;
  const PERFUMES_URL = `${root}collections/all?view=pl-parfumler`;
  const LABELS = { on: 'Karşılaştırmaya eklendi', off: 'Karşılaştırmaya ekle' };
  const ICON_RIGHT = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h16m-6-6 6 6-6 6"/></svg>';
  const ICON_CLOSE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="m5 5 14 14M19 5 5 19"/></svg>';
  const esc = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string' && h).filter((h, i, a) => a.indexOf(h) === i).slice(0, MAX) : [];
    } catch (e) { return []; }
  };
  const write = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* gizli pencere vb.: seçim yalnız bu sayfada kalır */ }
  };
  let selected = read();

  /* Kısa bildirim (ör. dördüncü formül) */
  let toastTimer;
  const toast = (message) => {
    let el = document.querySelector('.plr-compare-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'plr-compare-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2800);
  };

  /* Düğmeler: aria-pressed ve görünen etiket */
  const syncButtons = (scope = document) => {
    scope.querySelectorAll('[data-plr-compare]').forEach((button) => {
      const on = selected.includes(button.dataset.plrCompare);
      button.setAttribute('aria-pressed', String(on));
      button.classList.toggle('is-selected', on);
      const label = button.querySelector('[data-plr-compare-label]');
      if (label) label.textContent = on ? (button.dataset.labelOn || LABELS.on) : (button.dataset.labelOff || LABELS.off);
    });
  };

  /* Alt şerit: en az iki formül; sepet ve karşılaştırma sayfalarında yok (ürün sayfasında da görünür — kullanıcı isteği) */
  const trayAllowed = () => {
    const cls = document.body.classList;
    return !cls.contains('template-cart') && !document.querySelector('[data-plr-compare-page]');
  };
  const updateTray = () => {
    let tray = document.querySelector('.plr-compare-tray');
    const show = selected.length >= 2 && trayAllowed();
    if (!show) {
      if (tray) tray.hidden = true;
      document.body.classList.remove('plr-has-compare');
      return;
    }
    if (!tray) {
      tray = document.createElement('aside');
      tray.className = 'plr-compare-tray';
      tray.setAttribute('aria-label', 'Karşılaştırma seçimi');
      document.body.appendChild(tray);
    }
    tray.innerHTML = `
      <div class="plr-compare-tray__copy"><strong>${selected.length} formül seçildi</strong><span>En fazla üç formülü yan yana incele.</span></div>
      <a class="plr-compare-tray__go" href="${COMPARE_URL}">Karşılaştır ${ICON_RIGHT}</a>
      <button type="button" class="plr-compare-tray__clear" data-plr-compare-clear aria-label="Karşılaştırma seçimini temizle">${ICON_CLOSE}</button>`;
    tray.hidden = false;
    document.body.classList.add('plr-has-compare');
  };

  /* Karşılaştırma sayfası */
  const ROWS = [
    ['Koku karakteri', (d) => d.pfCharLabel || (d.pfChar || '').split('|').map((v) => v.trim()).filter(Boolean).join(' · ')],
    ['Tatlılık', (d) => d.pfSweet],
    ['Yayılım', (d) => d.pfProj],
    ['Tarz', (d) => d.pfStyle || d.pfGender],
    ['Konsantrasyon', (d) => d.pfConc],
    ['Hacim', (d) => d.volume || 'Belirtilmedi'],
    ['Kısa tanım', (d) => d.lead],
    ['Fiyat', (d) => d.price],
  ];
  const renderPage = () => {
    const page = document.querySelector('[data-plr-compare-page]');
    if (!page) return;
    const view = page.querySelector('[data-plr-compare-view]');
    const items = {};
    page.querySelectorAll('[data-plr-compare-item]').forEach((el) => { items[el.dataset.plrCompareItem] = el.dataset; });
    const chosen = selected.filter((handle) => items[handle]).map((handle) => ({ handle, d: items[handle] }));
    const perfumesUrl = page.dataset.perfumesUrl || PERFUMES_URL;
    let html;
    if (chosen.length >= 2) {
      const cell = (content, cls = '') => `<div class="plr-compare__cell${cls}">${content}</div>`;
      const head = chosen.map(({ handle, d }) => cell(`
        <div class="plr-compare__art">${d.image ? `<img src="${esc(d.image)}" alt="${esc(d.imageAlt || d.name)}" width="400" height="400" loading="lazy">` : ''}</div>
        <h3 class="plr-compare__name" lang="en">${esc(d.name)}</h3>
        <p class="plr-compare__code" lang="en">${esc(d.code)}</p>
        <button type="button" class="plr-compare__quiet" data-plr-compare-remove="${esc(handle)}" aria-label="${esc(d.name)} karşılaştırmadan kaldır">Kaldır</button>`, ' plr-compare__cell--head')).join('');
      const rows = ROWS.map(([label, get]) => cell(label, ' plr-compare__label') + chosen.map(({ d }) => cell(esc(get(d) || '–'), label === 'Fiyat' ? ' plr-compare__cell--price' : '')).join('')).join('');
      const actions = cell('Kararın', ' plr-compare__label') + chosen.map(({ d }) => cell(`<a class="plr-compare__btn plr-compare__btn--alt" href="${esc(d.url)}">Formülü incele</a>`)).join('');
      html = `
        <div class="plr-compare__scroll" role="region" aria-label="Yatay kaydırılabilir karşılaştırma" tabindex="0">
          <div class="plr-compare__table" style="--cols: ${chosen.length}">
            ${cell(`${chosen.length} formül`, ' plr-compare__label plr-compare__label--head')}${head}${rows}${actions}
          </div>
        </div>
        <p class="plr-compare__note">Konsantrasyon tek başına yayılım veya tende hissedilme süresi hakkında kesin sonuç vermez.</p>`;
    } else {
      html = `
        <div class="plr-compare__empty">
          <h2>İki formülle başlayalım.</h2>
          <p>Ürün kartlarındaki “Karşılaştır” seçeneğiyle en fazla üç parfümü yan yana inceleyebilirsin.${chosen.length ? ' Bir formül daha seç.' : ''}</p>
          <a class="plr-compare__btn" href="${esc(perfumesUrl)}">Parfümleri keşfet ${ICON_RIGHT}</a>
        </div>`;
    }
    html += `
      <div class="plr-compare__actions">
        <a class="plr-compare__back" href="${esc(perfumesUrl)}">Koleksiyona dön <span aria-hidden="true">↗</span></a>
        ${selected.length ? '<button type="button" class="plr-compare__quiet" data-plr-compare-clear>Karşılaştırmayı temizle</button>' : ''}
      </div>`;
    view.innerHTML = html;
  };

  const refresh = () => { syncButtons(); updateTray(); renderPage(); };
  const save = (list) => { selected = list.slice(0, MAX); write(selected); refresh(); };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-plr-compare]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      const handle = toggle.dataset.plrCompare;
      if (!handle) return;
      if (selected.includes(handle)) return save(selected.filter((h) => h !== handle));
      if (selected.length >= MAX) return toast('En fazla üç formülü karşılaştırabilirsin. Önce birini kaldır.');
      return save([...selected, handle]);
    }
    const remove = event.target.closest('[data-plr-compare-remove]');
    const clear = event.target.closest('[data-plr-compare-clear]');
    if (!remove && !clear) return;
    save(remove ? selected.filter((h) => h !== remove.dataset.plrCompareRemove) : []);
    /* Karşılaştırma sayfasında tablo kısalınca görünüm sayfa sonunda kalmasın */
    const view = document.querySelector('[data-plr-compare-view]');
    if (view && view.getBoundingClientRect().top < 0) {
      const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--plr-header-h')) || 90;
      window.scrollTo({ top: window.scrollY + view.getBoundingClientRect().top - header - 16 });
    }
  }, true);

  /* Başka sekmede değişirse ve geri tuşuyla dönülünce (önbellekten) güncel seçim */
  window.addEventListener('storage', (event) => { if (event.key === KEY) { selected = read(); refresh(); } });
  window.addEventListener('pageshow', (event) => { if (event.persisted) { selected = read(); refresh(); } });

  /* Sonradan yüklenen kartlar (öneriler, arama, son incelenenler) */
  let pending = false;
  const observer = new MutationObserver((mutations) => {
    if (pending) return;
    if (!mutations.some((m) => Array.from(m.addedNodes).some((n) => n.nodeType === 1 && (n.matches('[data-plr-compare]') || n.querySelector('[data-plr-compare]'))))) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; syncButtons(); });
  });

  const start = () => {
    refresh();
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
